import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { listWineRegions } from 'redux/productFilters/actions';

class WineRegionFilter extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const queryObj = queryString.parse(location.search);
    this.state = {
      wineRegion: queryObj.wineRegion
    };
  }

  componentDidMount() {
    this.listWineRegions();
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (prevProps.match.params.slug !== props.match.params.slug) {
      this.listWineRegions();
    }
  }

  listWineRegions = () => {
    const { props } = this;
    const { slug } = props.match.params;
    props.listWineRegions(slug);
  };

  handleChange = (e) => {
    const wineRegion = e.target.value;
    this.setState({ wineRegion });
    this.handleQueryChange(wineRegion);
  };

  handleQueryChange = (wineRegion) => {
    const { location, history } = this.props;
    const parsed = queryString.parse(location.search);
    if (wineRegion === '') {
      delete parsed.wineRegion;
    } else {
      parsed.wineRegion = wineRegion;
    }
    delete parsed.page;
    const stringified = queryString.stringify(parsed);
    let url = location.pathname;
    if (stringified.length > 0) {
      url += `?${stringified}`;
    }
    history.push(url);
  };

  render() {
    const { wineRegions } = this.props;
    const { wineRegion } = this.state;
    if (wineRegions.length === 0) {
      return null;
    }
    return (
      <>
        <div className="c7-selectbox">
          <label htmlFor="wineRegion">
            Region:
            <span className="c7-selectboxWrap">
              <select
                id="wineRegion"
                name="wineRegion"
                value={wineRegion}
                onChange={this.handleChange}
              >
                <option value="" />
                {wineRegions.map((wt) => (
                  <option value={wt.wineRegion} key={wt.wineRegion}>
                    {wt.wineRegion}
                  </option>
                ))}
              </select>
            </span>
          </label>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  wineRegions: state.productFilter.wineRegions
});

export default withRouter(
  connect(mapStateToProps, { listWineRegions })(WineRegionFilter)
);
